import { render } from "./loginfordocument.vue?vue&type=template&id=a2160170"
import script from "./loginfordocument.js?vue&type=script&lang=js"
export * from "./loginfordocument.js?vue&type=script&lang=js"

import "./loginfordocument.vue?vue&type=style&index=0&id=a2160170&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__